<div class="dialog dialog-small dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">Extended Earnings Benefit</h4>
    <div class="dialog-inner">The Extended Earnings Protection benefit provides financial support for insured
        individuals returning to full-time work post-disability but experiencing income loss. The insured must have
        received at least one monthly disability payment, must return to full-time work performing all regular
        procedures, and must earn less than 80% of pre-disability indexed earnings.</div>
    <div class="dialog-inner semibold">Additional Annual Cost</div>
   <div class="cost">{{cost ? (cost | currency) : 'Calculating...'}}</div>
    <!--
    <br />
    <mat-label class="label-text">Duration</mat-label>
    -->
    <br />
    <mat-form-field>
        <mat-label class="label-text">Maximum Duration</mat-label>
        <mat-select [(ngModel)]="EEBDuration" [disabled]="EEBDurationOptions.length <= 1"
            (selectionChange)="updateCost()">
            <mat-option *ngIf="EEBDurationOptions.length <= 0" value="{{EEBDuration}}">{{EEBDuration}}</mat-option>
            @for ( item of EEBDurationOptions; track item ) {
            <mat-option value="{{item}}">{{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <!--<div class="dialog-inner">Would you like to add this benefit to your policy?</div> -->
    <div *ngIf="!inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="no()" class="chat-button chat-button-define" mat-flat-button>Cancel</button>
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Add to Policy</button>

    </div>
    <div *ngIf="inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Close</button>
    </div>
    <br/>